import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { getMyRewardsPageUrl } from '../../../utils';
import { PageLink } from '../types';
import { Link } from '../Widget/types';

interface ResolveLinkParams {
  pageLink?: PageLink;
  flowAPI: ControllerFlowAPI;
}

export async function resolveLink({ pageLink, flowAPI }: ResolveLinkParams): Promise<Link | undefined> {
  const { wixCodeApi, platformAPIs } = flowAPI.controllerConfig;

  if (pageLink) {
    const target = 'target' in pageLink ? pageLink.target : undefined;
    const rel = 'rel' in pageLink && Array.isArray(pageLink.rel) ? pageLink.rel.join(' ') : undefined;

    if (pageLink.type === 'ExternalLink') {
      return {
        href: pageLink.url,
        target,
        rel,
      };
    }

    const baseUrl = wixCodeApi.location.baseUrl;
    const relativeUrl = platformAPIs.links?.toUrl(pageLink as any) ?? '';

    return {
      href: `${baseUrl}${relativeUrl}`,
      target,
      rel,
    };
  }

  const myRewardsPageUrl = await getMyRewardsPageUrl(flowAPI);
  if (!myRewardsPageUrl) {
    return;
  }

  return { href: myRewardsPageUrl };
}
